// extracted by mini-css-extract-plugin
module.exports = {"container":"EditTask_container__1Cqme","content":"EditTask_content__2Czvy","title":"EditTask_title__1T5Fj","closeButton":"EditTask_closeButton__jPz8K"};